"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MultiSampleDataSubheading_1 = require("./MultiSampleDataSubheading");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return MultiSampleDataSubheading_1.default; } });
